import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer'
import styles from "../../../../layout/layoutHeader/components/styles";

const showAllDrivers = ({ classes, ...props }) => {
  return (
    <Tooltip title="Enable/Disable Show All Drivers">
      <div className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${props.isMenuItem ? classes.toggleAnimationButtonMenu : ""}`}>
        <div className={classes.toggleText}>Show All Drivers</div>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={props.toggleShowAllDrivers}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(showAllDrivers);
